//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import moment from "moment";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateEmail } from "@/utils/validations.js";
import { validateDate } from "@/utils/validations.js";

export default {
  name: "traitsTab",
  props: ["value"],
  components: {},
  mounted: function() {
    BackendServices.getStorageTypes().then(response => {
      this.storage_types = response.data;
    });

    this.validateData();
  },
  data: () => ({
    tab: "traits",
    moment,
    weekdays: [
      { id: "0", opening_hour: null, closing_hour: null },
      { id: "1", opening_hour: null, closing_hour: null },
      { id: "2", opening_hour: null, closing_hour: null },
      { id: "3", opening_hour: null, closing_hour: null },
      { id: "4", opening_hour: null, closing_hour: null },
      { id: "5", opening_hour: null, closing_hour: null },
      { id: "6", opening_hour: null, closing_hour: null }
    ],
    time: null,
    storeList: [],
    storage_types: [],
    oldSchedule: []
  }),
  methods: {
    required,
    noValidation,
    validateEmail,
    validateDate,
    updateData() {
      this.$emit("value", this.value);
    },
    dayFormat(item) {
      return moment(item.id, "d").format("ddd");
    },
    validateData: function() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    EndDateValid(val) {
      if (val) {
        return val > this.activity_start || "Data inválida";
      }
    },
    endDateRestriction(date) {
      return date > this.value.activity_start;
    }
  }
};
